import { TrendDelta } from '@/components/shared/trend-delta'

interface TrendChipProps {
  /** Plain number delta: positive = up, negative = down, 0 = flat */
  value: number
}

export function TrendChip({ value }: TrendChipProps) {
  return <TrendDelta value={value} format="num" />
}
